import React, { useContext } from 'react'
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CloseButton from '../shared/CloseButton'
import { store } from '../../stores/team_pages'

export default function DeletePageModal(props) {
  const token = document.querySelector('[name="csrf-token"]').getAttribute('content')
  const { page, close, isOpen } = props
  const { scheduledShareCount } = page.attributes
  const { deleting, dispatch, actions } = useContext(store)

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch({
      type: actions.DELETE_PAGE,
      id: page.id,
    })
  }

  return (
    <Modal isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close} close={<CloseButton onClick={close} />} tag="h3">
        Delete this Page?
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <input type="hidden" value="delete" name="_method" />
        <input type="hidden" name="authenticity_token" value={token} />
        <input type="hidden" name="return_to" value={window.location} />
        <ModalBody>
          Are you sure you want to delete this page?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" type="submit" disabled={deleting}>{deleting ? 'Deleting…' : 'Delete'}</Button>
          <Button color="outline-secondary" onClick={close}>Cancel</Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}
